// TPOS-10162 PR review (4th round): save paths resolve with a small result object rather than
// throwing, so callers can tell three outcomes apart:
//
//   { saved: true }                                 the save actually happened
//   { skipped: true, reason: 'locationChanged' }    the cross-location guard fired
//   { skipped: true, reason: 'cancelled' }          the user declined the ">6 changes" confirm
//   undefined                                       the save threw and a mixin swallowed the error
//
// Rounds 1-3 used a bare { skipped: true } for both skip cases, so every skip handler reported
// "the active location changed" even when the user had simply clicked Cancel. These helpers keep
// that distinction in one place instead of eight ad-hoc checks.

export const SKIP_REASON = {
  LOCATION_CHANGED: 'locationChanged',
  CANCELLED: 'cancelled'
}

export function wasSaved (result) {
  return !!(result && result.saved)
}

export function wasSkipped (result) {
  return !!(result && result.skipped)
}

// The user chose this outcome, so it is not an error and should not be announced back to them.
export function wasCancelledByUser (result) {
  return wasSkipped(result) && result.reason === SKIP_REASON.CANCELLED
}

// Only claim a location change when that is genuinely why the save was skipped; otherwise stay
// cause-neutral rather than inventing an explanation.
export function skipWarning (result, subject) {
  if (result && result.reason === SKIP_REASON.LOCATION_CHANGED) {
    return `The active location changed while saving — your changes to the ${subject} were NOT ` +
      `saved. Please reload the page and re-apply them.`
  }
  return `Your changes to the ${subject} were NOT saved. Please try again.`
}
